module.exports = __webpack_public_path__ + "img/alfabank.9b655e5e.svg";